import { render, staticRenderFns } from "./declareRankDetails.vue?vue&type=template&id=161f7690&scoped=true&"
import script from "./declareRankDetails.vue?vue&type=script&lang=js&"
export * from "./declareRankDetails.vue?vue&type=script&lang=js&"
import style0 from "./declareRankDetails.vue?vue&type=style&index=0&id=161f7690&prod&scoped=true&lang=css&"
import style1 from "./declareRankDetails.vue?vue&type=style&index=1&id=161f7690&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f7690",
  null
  
)

export default component.exports